import { render } from "./RoundedSlideGroup.vue?vue&type=template&id=682c5cb6&scoped=true"
import script from "./RoundedSlideGroup.vue?vue&type=script&lang=js"
export * from "./RoundedSlideGroup.vue?vue&type=script&lang=js"

import "./RoundedSlideGroup.vue?vue&type=style&index=0&id=682c5cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c5cb6"]])

export default __exports__